import React, { useEffect } from 'react';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { Constants } from '../../../../common/Constants';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { useLagoon } from '../../../../hooks/useLagoon';
import { useStore } from '../../../../hooks/useStore/useStore';

declare global {
  interface Window {
    lpTag: any;
  }
}

const initializeClickTracking = () => {
  const trackChatButtonClick = () => {
    adobeLinkTrackEvent({
      name: Constants.LIVE_PERSON_MESSAGE_US,
      location: 'global chat',
      type: 'internal',
    });
  };
  let timesRun = 0;
  const interval = setInterval(() => {
    timesRun += 1;
    if (window.lpTag) {
      window.lpTag?.events?.bind?.('*', 'OFFER_CLICK', trackChatButtonClick);
      clearInterval(interval);
    }
    if (timesRun === 5) {
      clearInterval(interval);
    }
  }, 1000);
};

export const LivePerson = () => {
  const livePerson = useLagoon('global-chat')();
  const { isLoggedInMember } = useStore((state) => state.planSelector);
  const isChatEnabledForProxy = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_CHAT_FOR_PROXY_USERS,
  ])[0];

  const isChatEnabled = isLoggedInMember || isChatEnabledForProxy;

  useEffect(() => {
    // Live Person script checks
    if (isChatEnabled && livePerson[0]?.script && livePerson[0]?.active) {
      const livePersonScript = document.createElement('script');
      livePersonScript.type = 'text/javascript';
      livePersonScript.async = true;
      livePersonScript.src = livePerson[0]?.script;
      livePersonScript.onload = () => {
        initializeClickTracking();
      };
      document.head.appendChild(livePersonScript);
    }
  }, [isChatEnabled]);

  return <React.Fragment />;
};
